import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';
import type { HTMLAttributes } from 'react';
type AnimatedContainerProps = HTMLAttributes<HTMLDivElement> & {
  isExpanded: boolean;
  children: React.ReactNode;
  className?: string;
};
const AnimatedContainer = t0 => {
  const $ = _c(6);
  const {
    isExpanded,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== isExpanded) {
    t1 = isExpanded ? <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} className={className}>{children}</motion.div> : null;
    $[0] = children;
    $[1] = className;
    $[2] = isExpanded;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default AnimatedContainer;